<!--  -->
<template>
  <div class="pd90">
    <div class="search-box">
      <div class="container pt30">
        <div class="con-sub">
          <div class="sub-title">全部结果 ></div>
          <el-tag
            v-for="(tag,index) in tags"
            :key="index"
            :disable-transitions="true"
            closable
            @close="handleClose(tag)"
            :hit="true"
          >
            <span v-if="tag.key=='姓名'" class="tag-text tag-text1"></span>
            <span v-if="tag.key=='单位'" class="tag-text tag-text2"></span>
            <span v-if="tag.key=='研究领域'" class="tag-text tag-text3"></span>
            <span v-if="tag.value">{{tag.value}}</span>
            <span v-if="tag.key" class="tag-solt">{{tag.key | Tagstext}}</span>
          </el-tag>
          <span class="tips">提示：支持姓名/单位/领域的复合搜索</span>
        </div>
        <div class="con-sub">
          <div class="sub-title">选择学科：</div>
          <el-dropdown @command="handleCommand1" trigger="click">
            <span class="el-dropdown-link">
              {{command1}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>学科门类</el-dropdown-item>
              <el-dropdown-item
                v-for="(item,index) in commandData1"
                :key="index"
                :command="item"
              >{{item['name']}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand2" trigger="click">
            <span class="el-dropdown-link">
              {{command2}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>一级学科</el-dropdown-item>
              <el-dropdown-item
                v-for="(item,index) in commandData2"
                :key="index"
                :command="item"
              >{{item['name']}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand3" trigger="click">
            <span class="el-dropdown-link">
              {{command3}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>二级学科</el-dropdown-item>
              <el-dropdown-item
                v-for="(item,index) in commandData3"
                :key="index"
                :command="item"
              >{{item['name']}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="con-sub">
          <div class="sub-title">选择评级：</div>
          <div
            v-for="(item,index) in chooseClass"
            :key="index"
            :class="item.index==classActive?'sub-active':''"
            class="sub-item"
            @click="chooseIt(item)"
          >{{item.name}}</div>
        </div>
      </div>
    </div>
    <hr>
    <div class="search-con">
      <div class="container">
        <div class="title">
          为您找到相关结果
          <span>{{scholarCount}}</span> 条
        </div>
        <div class="table clearf" v-loading="scholarLoading">
          <el-col :span="12" v-for="item in scholarLists" :key="item['id']" class="table-item">
            <div
              class="table-box"
              @click="goHomePage(item['aid'],item['treecode'],item['itreecode'])"
            >
              <img class="table-img" :src="item.iavater" alt>
              <div class="item-box">
                <div class="box-title">{{item.itreecode}}</div>
                <div class="box-name">{{item.iname?item.iname:item.name}}<span class="author-ise">ISE:{{item.ise}}</span></div>
                <div class="box-company">单位：{{item.icompany?item.icompany:item.company}}</div>
                <div class="box-field">研究领域：{{item.ikeywords | lengthOf25(25)}}</div>
              </div>
            </div>
          </el-col>
          <div v-if="!scholarCount" class="no-data">
            <img src="../assets/img/nodata.png" alt>
            <p>暂无搜索结果</p>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="iseparams.pageindex"
            :page-size="10"
            layout="prev, pager, next"
            :total="scholarCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用

  components: {},
  data() {
    //这里存放数据
    return {
      tags: [],
      classActive: 0,
      command1: "学科门类",
      command2: "一级学科",
      command3: "二级学科",
      chooseClass: [
        {
          name: "全部",
          index: 0
        },
        {
          name: "AAAAA",
          index: 1
        },
        {
          name: "AAAA",
          index: 2
        },
        {
          name: "AAA",
          index: 3
        }
      ],
      val1: this.$store.state.searchInput.value,
      key1: this.$store.state.searchInput.key,
      currentPage: 1,
      classData: [],
      commandData1: [],
      commandData2: [],
      commandData3: [],
      iseparams: {
        ikeywords: "",
        treecode: "",
        pagesize: 10,
        pageindex: 1,
        name: "",
        company: "",
        ise: ""
      },
      scholarLists: [],
      scholarCount: 0,
      scholarLoading: false
    };
  },
  //监听属性 类似于data概念
  computed: {
    newName() {
      return this.$store.state.searchInput;
    },
    classObject: function() {
      console.log(this.key1);
    }
  },
  //监控data中的数据变化
  watch: {
    tags: {
      handler(newValue, oldValue) {
        //console.log(newValue);
      }
    },
    commandData2: {
      handler(newValue, oldValue) {
        this.command2 = "一级学科";
        this.commandData3 = [];
      },
      deep: true
    },
    commandData3: {
      handler(newValue, oldValue) {
        this.command3 = "二级学科";
      },
      deep: true
    },
    newName(obj) {
      this.val1 = obj.value;
      this.key1 = obj.key;
      console.log(obj)
      this.searchAll();
    }
  },
  //方法集合
  methods: {
    goHomePage(aid, code, substr) {
      this.$router.push({
        path: "/homepage",
        query: {
          id: aid,
          treecode: code,
          substr: substr
        }
      });
    },
    searchData() {
      let params = {};
      let _this = this;
      _this.$api
        .fetchGet("/iseapi/getisetreecode", params)
        .then(res => {
          if (res.error === 0) {
            _this.classData = res.data;
            res.data.forEach((item, index) => {
              if (item["topid"] === "0") {
                _this.commandData1.push(item);
              }
            });
            //_this.changeNav(_this.navData[0])
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    chooseIt(item) {
      if (!this.scholarLoading) {
        this.classActive = item.index;
        if (item.name == "全部") {
          this.iseparams.ise = "";
        } else {
          this.iseparams.ise = item.name;
        }
        this.iseparams.pageindex = 1;
        this.getIseSearchList();
      }
    },
    handleClose(tag) {
      if (!this.scholarLoading) {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.contorlTags();
        this.getIseSearchList();
      }
    },
    //搜索方法
    searchAll() {
      if (!this.scholarLoading) {
        let tagkey = true;
        let _this = this;
        for (let i = 0; i < _this.tags.length; i++) {
          if (_this.key1 == _this.tags[i].key) {
            _this.tags.splice(i,1)
          } else {
            tagkey = true;
          }
        }
        if (tagkey) {
          let tag = {
            key: _this.key1,
            value: _this.val1
          };
          _this.tags.push(tag);
        }
        console.log(_this.tags)
        this.contorlTags();
        this.getIseSearchList();
      }
    },
    //控制名字公司的搜索
    contorlTags() {
      let _this = this;
      _this.iseparams.name = "";
      _this.iseparams.company = "";
      _this.iseparams.ikeywords = "";
      _this.iseparams.pageindex = 1;
      for (let item of _this.tags) {
        switch (item["key"]) {
          case "姓名":
            _this.iseparams.name = item["value"];
            break;
          case "单位":
            _this.iseparams.company = item["value"];
            break;
          case "研究领域":
            _this.iseparams.ikeywords = item["value"];
            break;
          default:
            break;
        }
      }
      
    },
    //搜索页面
    getIseSearchList() {
      let params = this.iseparams;
      console.log(this.iseparams)
      let _this = this;
      _this.scholarLoading = true;
      _this.$api
        .fetchGet("/iseapi/getisesearchlist", params)
        .then(res => {
          if (res.error === 0) {
            _this.scholarLists = res["data"];
            _this.scholarCount = res["totalcount"];
            _this.scholarLoading = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleCommand1(item) {
      if (!this.scholarLoading) {
        let _this = this;
        console.log(item);
        _this.command1 = item["name"];
        _this.commandData2 = [];
        for (let it of _this.classData) {
          if (it["topid"] == item["id"] && +it["firstid"] == 0) {
            _this.commandData2.push(it);
          }
        }
        _this.iseparams.treecode = item["id"];
        _this.iseparams.pageindex = 1;
        _this.getIseSearchList();
      }

      //调接口
    },
    handleCommand2(item) {
      if (!this.scholarLoading) {
        let _this = this;
        console.log(item);
        _this.command2 = item["name"];
        _this.commandData3 = [];
        for (let it of _this.classData) {
          if (it["firstid"] == item["id"] && it["topid"] == item["topid"]) {
            _this.commandData3.push(it);
          }
        }
        _this.iseparams.treecode = item["topid"] + item["id"];
        _this.iseparams.pageindex = 1;
        _this.getIseSearchList();
      }
    },
    handleCommand3(item) {
      if (!this.scholarLoading) {
        let _this = this;
        _this.command3 = item["name"];
        console.log(item);
        _this.iseparams.treecode = item["topid"] + item["firstid"] + item["id"];
        _this.iseparams.pageindex = 1;
        _this.getIseSearchList();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (!this.scholarLoading) {
        this.iseparams.pageindex = val;
        this.getIseSearchList();
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.val1) {
      let tag = {
        key: this.key1,
        value: this.val1
      };
      this.tags.push(tag);
    }
    console.log(this.tags);
    this.contorlTags();
    this.getIseSearchList();
    // this.iseparams.name = this.tags[0]["value"];
    // this.getIseSearchList();
    this.searchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
hr {
  height: 2px;
  background-color: #f1f1f1;
  border: none;
  margin-top: 30px;
  margin-bottom: 35px;
}
.pt30 {
  padding-top: 30px;
}
.pd90 {
  padding-bottom: 90px;
}
.search-box .tips {
  margin-left: 32px;
  font-size: 14px;
  color: #999;
}
.search-box .con-sub {
  margin-top: 15px;
}
.search-box .con-sub:first-child {
  height: 32px;
  margin-top: 0;
  line-height: 32px;
}

.search-box .con-sub .sub-title,
.search-box .con-sub .sub-item {
  display: inline-block;
  font-size: 14px;
}
.search-box .con-sub .sub-item {
  margin-left: 30px;
  padding: 5px 15px;
  cursor: pointer;
}
.sub-active {
  background: rgba(66, 103, 178, 1);
  border-radius: 2px;
  color: #fff;
}
.search-con .table {
  margin-top: 30px;
}
.search-con .table .table-box {
  width: 480px;
  cursor: pointer;
}
.search-con .title {
  color: #999999;
  font-size: 14px;
}
.search-con .title span {
  color: #333333;
}
.table-item {
  margin-bottom: 40px;
}
.item-box {
  font-size: 14px;
}
.box-title {
  color: #999;
}
.box-name {
  margin-top: 15px;
  margin-bottom: 20px;
  font-size: 18px;
  /* font-weight: 700; */
}
.box-company,
.box-field {
  line-height: 22px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.table-img {
  width: 90px;
  height: 120px;
  border-radius: 3px;
  float: left;
  margin-right: 15px;
}
.search-box .el-tag {
  margin-left: 30px;
  font-size: 14px;
  color: rgba(66, 103, 178, 1);
  border-style: dashed
}
.search-box .el-tag .el-tag__close {
    color: rgba(66, 103, 178, 1) !important;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.tag-solt {
  margin-left: 5px;
  background-color: #b38e65;
  color: #fff;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 12px;
}
.tag-text {
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 4px;
  display: inline-block;
  height: 16px;
  width: 14px;
}
.tag-text1 {
  top: 5px;
  background: url("../assets/1.svg") no-repeat;
}
.tag-text2 {
  background: url("../assets/2.svg") no-repeat;
}
.tag-text3 {
  top: 3px;
  background: url("../assets/3.svg") no-repeat;
}
.box-name .author-ise {
    background-color: #B38E65;
    padding: 2px 8px;
    font-size: 14px;
    color: #fff;
    border-radius: 2px;
    margin-left: 30px;
    position: relative;
    top: -1px;
}

.el-table th {
  background: rgba(66, 103, 178, 0.06);
  color: #999999 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4267b2 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/Search.vue